/**
 * Gets a value from a nested object using a flattened path
 * @param {Object} obj - The object to search in
 * @param {string} flattenField - Dot-notation path (e.g., 'city.ibge')
 * @returns {*} The value at the specified path, or undefined if not found
 *
 * @example
 * getValueFromFlattenObj({ city: { ibge: 123 } }, 'city.ibge')
 * // Returns: 123
 *
 * @example
 * getValueFromFlattenObj({ city: { name: 'SP' } }, 'city.ibge')
 * // Returns: undefined
 *
 * @example
 * getValueFromFlattenObj({ entity: { address: { city: { ibge: 456 } } } }, 'entity.address.city.ibge')
 * // Returns: 456
 *
 * @example
 * getValueFromFlattenObj(null, 'city.ibge')
 * // Returns: undefined
 */
export const getValueFromFlattenObj = (obj, flattenField = '') => {
  // Validate inputs
  if (!obj || typeof obj !== 'object') {
    return undefined;
  }

  if (!flattenField || typeof flattenField !== 'string') {
    return obj;
  }

  const keys = flattenField.split('.');

  // Navigate through the object using the keys
  let current = obj;

  for (const key of keys) {
    if (current === null || current === undefined) {
      return undefined;
    }

    if (typeof current !== 'object') {
      return undefined;
    }

    current = current[key];
  }

  return current;
};

export default getValueFromFlattenObj;
